import { Action } from 'redux';

export const setPricingAsCurrentSection = (): Action<string> => ({
  type: 'PRICING',
});

export const setBrokerAsCurrentSection = (): Action<string> => ({
  type: 'BROKER',
});
